import { pageHeaderAtom } from 'lib/atoms'
import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { CoursePageLink } from 'types/course'

type usePageHeaderProps = {
  title: string | undefined
  titlePrefix: string | undefined
  backLinkHref: string | undefined
  backLinkText: string | undefined
  loading: boolean
  pages?: CoursePageLink[]
  courseHasAssessments?: boolean
}

const usePageHeader = ({
  title,
  titlePrefix,
  backLinkHref,
  backLinkText,
  loading,
  pages = [],
  courseHasAssessments,
}: usePageHeaderProps) => {
  const setPageHeader = useSetRecoilState(pageHeaderAtom)

  useEffect(() => {
    if (title) {
      setPageHeader({
        title,
        titlePrefix: titlePrefix || '',
        backLinkHref: backLinkHref || '',
        backLinkText: backLinkText || '',
        loading: loading,
        pages,
        courseHasAssessments:
          typeof courseHasAssessments === 'boolean'
            ? courseHasAssessments
            : true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    title,
    titlePrefix,
    backLinkHref,
    backLinkText,
    pages,
    courseHasAssessments,
  ])
}

export default usePageHeader
